"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsSchema = exports.AppConfigurationsSchema = exports.AgentStatusTimeLimitSchema = exports.DPASettingsSchema = exports.UserSettingsSchema = void 0;
const yup_1 = require("yup");
const model_schema_1 = require("../base/model.schema");
const company_schema_1 = require("../company/company.schema");
exports.UserSettingsSchema = (0, yup_1.object)({
    mandateMFA: (0, yup_1.boolean)().notRequired(),
    usernameValidationRegex: (0, yup_1.string)().notRequired(),
    usernameValidationDescription: (0, yup_1.string)().notRequired(),
});
exports.DPASettingsSchema = (0, yup_1.object)({
    showAnswers: (0, yup_1.boolean)().notRequired(),
});
exports.AgentStatusTimeLimitSchema = (0, yup_1.array)((0, yup_1.object)({
    agentStatus: (0, yup_1.string)().notRequired(),
    timeLimitSecs: (0, yup_1.number)().notRequired(),
}));
exports.AppConfigurationsSchema = (0, yup_1.object)({
    callHistoryHours: (0, yup_1.number)().notRequired(),
    isAfterCallWorkLimited: (0, yup_1.boolean)().notRequired(),
    afterCallWorkTimeoutSeconds: (0, yup_1.number)().notRequired(),
    allowAfterCallWorkExtension: (0, yup_1.boolean)().notRequired(),
    allowCCPWindow: (0, yup_1.boolean)().notRequired(),
    chat: (0, yup_1.object)({
        callHistoryHours: (0, yup_1.number)().notRequired(),
        isAfterCallWorkLimited: (0, yup_1.boolean)().notRequired(),
        afterCallWorkTimeoutSeconds: (0, yup_1.number)().notRequired(),
        allowAfterCallWorkExtension: (0, yup_1.boolean)().notRequired(),
        allowCCPWindow: (0, yup_1.boolean)().notRequired(),
    }),
    task: (0, yup_1.object)({
        callHistoryHours: (0, yup_1.number)().notRequired(),
        isAfterCallWorkLimited: (0, yup_1.boolean)().notRequired(),
        afterCallWorkTimeoutSeconds: (0, yup_1.number)().notRequired(),
        allowAfterCallWorkExtension: (0, yup_1.boolean)().notRequired(),
        allowCCPWindow: (0, yup_1.boolean)().notRequired(),
    })
});
exports.SettingsSchema = model_schema_1.Schema.shape({
    user: exports.UserSettingsSchema.notRequired(),
    keywordManagement: company_schema_1.keywordManagement.notRequired(),
    dpa: exports.DPASettingsSchema.notRequired(),
    agentStatusTimes: exports.AgentStatusTimeLimitSchema.notRequired(),
    appConfigurations: exports.AppConfigurationsSchema.notRequired(),
});
